import { useContext } from "react";
import PagePosts from "../subpages/PagePosts";
import PageProfile from "../subpages/PageProfile";
import PageAccount from "../subpages/PageAccount";
import PageDatabases from '../subpages/PageDatabases'
import { PageContext, PAGE_ANNOUNCE, PAGE_OWN, PAGE_DATABASE, PAGE_ACCOUNT, PAGE_LOCK, PAGE_SUMMARY, PAGE_FAQ, PAGE_MAOLAM_REGISTER, PAGE_MAOLAM_APPROVE } from "../contexts/PageContext";
import { AuthContext } from "../contexts/AuthContext";
import PageLocks from "../subpages/PageLocks";
import PageDownload from "../subpages/PageDownload";
import PageFaq from "../subpages/PageFaq";
import PageMaolamRegister from "../subpages/PageMaolamRegister";
import PageMaolamApprove from "../subpages/PageMaolamApprove";



const PagePrivate = () => {
    const { page } = useContext(PageContext);
    const { userRole } = useContext(AuthContext)

    return (
        <div>
            <div className="d-sm-none"><br /><br /><br /></div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_MAOLAM_REGISTER}>
                <PageMaolamRegister />
            </div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_ANNOUNCE}>
                <PagePosts />
            </div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_OWN}>
                <PageProfile />
            </div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_FAQ}>
                <PageFaq />
            </div>
            <div className="container-fluid" style={{maxWidth : '768px'}} hidden={page !== PAGE_ACCOUNT}>
                <PageAccount />
            </div>
            
            {userRole ? <div className="container-fluid" style={{maxWidth : '1400px'}} hidden={page !== PAGE_DATABASE || !userRole}>
                <PageDatabases />
            </div> : <></>}
            {userRole ? <div className="container-fluid" style={{maxWidth : '1400px'}} hidden={page !== PAGE_LOCK || !userRole}>
                <PageLocks />
            </div> : <></>}
            {userRole >= 2 ? <div className="container-fluid" style={{maxWidth : '1400px'}} hidden={page !== PAGE_MAOLAM_APPROVE || userRole < 2}>
                <PageMaolamApprove />
            </div> : <></>}
            {userRole >= 2 ? <div className="container-fluid" style={{maxWidth : '1400px'}} hidden={page !== PAGE_SUMMARY || userRole < 2}>
                <PageDownload />
            </div> : <></>}
        </div>
    )

}

export default PagePrivate;